module.exports = __webpack_public_path__ + "static/media/back.05f32eb1.svg";